import React from 'react';

const AboutOurVisionSection = () => (
    <section className="lp-about-vision" style={{ backgroundImage: `url(${require('../../../../images/landing-pages/about-us/our-vision-bg.png')})` }}>
        <div className="lp-container lp-about-vision-inner">
            <div className="lp-about-vision-eyebrow" data-lp-reveal>Our Vision</div>
            <h2 className="lp-about-vision-h" data-lp-reveal data-lp-delay="60">
                <span className="muted">Replacing</span>
                <span className="pink">periodic transaction diligence</span>
                <span className="muted">with</span>
                <span className="white">Continuous Corporate Health Monitoring</span>
            </h2>
            <p className="lp-about-vision-sub" data-lp-reveal data-lp-delay="120">
                <u>Diligentsia</u> ensures SMEs are perpetually exit-ready — transforming diligence from a one-off cost into a continuous <span className="pink">value-creation engine</span>
            </p>
        </div>
    </section>
);

export default AboutOurVisionSection;
